module.exports = __webpack_public_path__ + "components/guide-page/static/icon-gloves-c6e8659d1e73db58334d6ea404400214.svg";